// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard .products-container {
  font-size: 14px;
}

.dashboard .products-container .table thead {
  background: #f6f6fe !important;
}

.dashboard .products-container .table thead th {
  border: 0;
}

.dashboard .products-container .table tbody td {
  vertical-align: middle;
}

.dashboard .products-container img {
  border-radius: 5px;
  max-width: 60px;
}

.dashboard .products-container .icon {
  border-radius: 5px;
  max-width: 60px;
  max-height: 60px;
  width: 60px;
  height: 45px;
}
`, "",{"version":3,"sources":["webpack://./src/components/proto/components/Productos/productosTable.css"],"names":[],"mappings":"AAAA;EACE,eAAe;AACjB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,YAAY;AACd","sourcesContent":[".dashboard .products-container {\n  font-size: 14px;\n}\n\n.dashboard .products-container .table thead {\n  background: #f6f6fe !important;\n}\n\n.dashboard .products-container .table thead th {\n  border: 0;\n}\n\n.dashboard .products-container .table tbody td {\n  vertical-align: middle;\n}\n\n.dashboard .products-container img {\n  border-radius: 5px;\n  max-width: 60px;\n}\n\n.dashboard .products-container .icon {\n  border-radius: 5px;\n  max-width: 60px;\n  max-height: 60px;\n  width: 60px;\n  height: 45px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
